type ScrollCueProps = {
  label: string;
  /** how far down one tap moves the page, as a share of the viewport height */
  step?: number;
  className?: string;
  labelClassName?: string;
  trackClassName?: string;
  fillClassName?: string;
  iconClassName?: string;
};

/**
 * Clickable "there is more below" hint:
 * label + animated line + arrow. One tap scrolls roughly one screen further down.
 */
export default function ScrollCue({
  label,
  step = 0.75,
  className = "",
  labelClassName = "",
  trackClassName = "",
  fillClassName = "",
  iconClassName = "",
}: ScrollCueProps) {
  const handleClick = () => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const viewport = window.innerHeight;
    const distance = Math.max(220, viewport * step);
    const remaining = Math.max(
      0,
      document.documentElement.scrollHeight - viewport - window.scrollY
    );
    const target = window.scrollY + Math.min(distance, remaining);

    window.scrollTo({
      top: target,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={`${label}: weiter nach unten scrollen`}
      className={`group flex cursor-pointer flex-col items-center gap-3 bg-transparent ${className}`}
    >
      <span
        className={`text-[10px] uppercase tracking-[0.4em] transition-opacity duration-300 group-hover:opacity-100 ${labelClassName}`}
      >
        {label}
      </span>

      <span
        className={`relative h-16 w-px overflow-hidden ${trackClassName}`}
      >
        <span className={`scroll-line absolute inset-0 ${fillClassName}`} />
      </span>

      <i
        aria-hidden="true"
        className={`ri-arrow-down-line text-lg leading-none transition-transform duration-300 group-hover:translate-y-1 ${iconClassName}`}
      ></i>
    </button>
  );
}